import { useMemo } from 'react'
import { type BeforeMaskedStateChangeStates } from 'react-input-mask'

import brazilianBanks from '../../../../../../../mocks/brazilianBanks'

export const useBankStepForm = () => {
  const brazilianBankOptions = useMemo(() => {
    return brazilianBanks.map(({ COMPE, LongName }) => ({
      label: `${COMPE} - ${LongName}`,
      value: `${COMPE} - ${LongName}`,
    }))
  }, [brazilianBanks])

  const handleBeforeMaskedBankBranchChangeStates = ({
    nextState,
  }: BeforeMaskedStateChangeStates) => {
    let { value } = nextState

    if (value.length === 5) {
      value = value.replace(/\D+/g, '')
    }

    return {
      ...nextState,
      value,
    }
  }

  const handleBeforeMaskedCurrentAccountChangeStates = ({
    nextState,
  }: BeforeMaskedStateChangeStates) => {
    let { value } = nextState

    if (value.length >= 5) {
      value = value.replace(/\D+/g, '').replace(/(\d{4,9})(\d{1})/, '$1-$2')
    }

    return {
      ...nextState,
      value,
    }
  }

  return {
    brazilianBankOptions,
    handleBeforeMaskedBankBranchChangeStates,
    handleBeforeMaskedCurrentAccountChangeStates
  }
}
